import { Box, Button } from "@mui/material";
import { DataGrid, gridClasses, GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import axios from "axios";
import React, { useEffect, useState } from "react";

const Units = () => {
  const [units, setUnits] = useState([]);
  const [addUnit, setAddUnit] = useState();
  const [btnLoading, setBtnLoading] = useState(false);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setAddUnit({ ...addUnit, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/unit`, {
        headers: { Authorization: `Bearer ${storedUser.accessToken}` },
      });
      setUnits(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const data = addUnit || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.title)) newErrors.title = "Unit Title is required";
    if (isEmpty(data.shortform)) {
      newErrors.shortform = "Unit Shortform is required";
    }
    if (isEmpty(data.category)) newErrors.category = "Category is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddCategory = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/unit`,
        {
          title: addUnit.title,
          shortform: addUnit.shortform,
          category: addUnit.category,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setAddUnit("");
      fetchUnits();
    } catch (err) {
      console.error(err);
    } finally {
      setBtnLoading(false);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Sr. No.",
      flex: 1,
    },
    {
        field: "title",
        headerName: "Title",
        flex: 1,
      },
      {
        field: "shortform",
        headerName: "Shortform",
        flex: 1,
      },
      {
        field: "category",
        headerName: "Category",
        flex: 1,
      },
]
  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <div className="dashboard-container">
        <h2>Add Unit</h2>
        <div style={{ display: "flex", columnGap: 25 }}>
          <div style={{ width: "100%" }}>
            <input
              className={`${errors.title && "input-error"}`}
              type="text"
              name="title"
              id="title"
              placeholder="Unit Title"
              value={addUnit && addUnit.title}
              onChange={handleChange}
            />
            {errors.title && <p className="error">{errors.title}</p>}
          </div>
          <div style={{ width: "100%" }}>
            <input
              className={`${errors.shortform && "input-error"}`}
              type="text"
              name="shortform"
              id="shortform"
              placeholder="Unit Shortform"
              value={addUnit && addUnit.shortform}
              onChange={handleChange}
            />
            {errors.shortform && <p className="error">{errors.shortform}</p>}
          </div>
          <div style={{ width: "100%" }}>
            <input
              className={`${errors.category && "input-error"}`}
              type="text"
              name="category"
              id="category"
              placeholder="Category"
              onChange={handleChange}
              value={addUnit && addUnit.category}
            />
            {errors.category && <p className="error">{errors.category}</p>}
          </div>
        </div>
        <div className="btn-container">
          <Button
            sx={{ margin: "5px 0 20px 0 !important" }}
            className="btn-contained"
            onClick={handleAddCategory}
          >
            Add
          </Button>
        </div>

        <h2 style={{ marginTop: "30px" }}>All Units</h2>
        <Box sx={{ width: "100%", minHeight: "400px" }}>
              <DataGrid
                rows={units}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10,
                    },
                  },
                }}
                pageSizeOptions={[10]}
                disableRowSelectionOnClick
                disableColumnSelector
                disableDensitySelector
                disableColumnMenu
                disableColumnResize
                slots={{ toolbar: CustomToolbar }}
                getRowId={(row) => row.id}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
                }
                sx={{
                  position: "relative",
                  border: "none",
                  fontFamily: "Inter !important",
        
                  "& .MuiDataGrid-columnHeaderTitle": {
                    fontWeight: "700 !important",
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    background: "none !important",
                    color: "black",
                    fontSize: "14px",
                    borderRadius: "10px",
                  },
                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#fff",
                  },
                  "& .MuiDataGrid-cell": {
                    fontSize: "13px",
                    border: "none",
                  },
                  "& .MuiDataGrid-columnSeparator": {
                    display: "none",
                  },
                  "& .css-1ccsd5i-MuiButtonBase-root-MuiButton-root": {
                    color: "#000 !important",
                    border: "1px solid #B0B0B0",
                    borderRadius: "12px",
                    padding: 1,
                  },
                  "& .MuiInputBase-root-MuiInput-root::after": {
                    borderBottom: "none !important",
                  },
                  "& .MuiInputBase-root-MuiInput-root": {
                    borderBottom: "none !important",
                  },
                  [`& .${gridClasses.row}.even`]: {
                    backgroundColor: "#EAF4FF",
                    // '&:hover': {
                    //   backgroundColor: "#f6f6f6",
                    // },
                  },
                  "& .MuiInput-underline:before": {
                    borderBottom: "none !important",
                  },
                  "& .css-5h82ro-MuiInputBase-root-MuiInput-root::after": {
                    borderBottom: "none !important",
                  },
                }}
              />
            </Box>
      </div>
    </div>
  );
};

export default Units;

function CustomToolbar() {
  return (
    <GridToolbarContainer sx={{ display: "flex", justifyContent: "end" }}>
      <GridToolbarQuickFilter
        sx={{
          border: "1px solid #B0B0B0",
          borderRadius: "12px",
          padding: "4px 12px",
          "&:hover": {
            backgroundColor: "#D8E9F0",
          },
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          },
          width: 300,
        }}
      />
      {/* <GridToolbarFilterButton /> */}
    </GridToolbarContainer>
  );
}
